import React from 'react';
import {
    ArrowLeftRight,
    Blocks,
    Box,
    ChartNoAxesColumn,
    CirclePercent,
    CircleStop,
    ClipboardList,
    CloudRain,
    Columns2,
    Compass,
    Dog,
    GitCompareArrows,
    Grid2X2Check,
    Grid3X3,
    History,
    LetterText,
    LibraryBig,
    ListMusic,
    ListRestart,
    MapPinCheckInside,
    Orbit,
    Puzzle,
    Route,
    Ruler,
    Scale,
    ScanEye,
    ScanText,
    Search,
    TableProperties,
} from 'lucide-react';

export const BRAIN_GAME_CARD_ICON_CONFIG = Object.freeze({
    'memory-match': { Icon: Dog, tone: 2 },
    'memory-matrix': { Icon: Grid3X3, tone: 1 },
    'sequence-repeat': { Icon: ListRestart, tone: 2 },
    'symbol-n-back': { Icon: History, marker: 'N', tone: 3 },
    'stroop-colors': { Icon: LetterText, marker: 'RGB', tone: 4 },
    'schulte-table': { Icon: TableProperties, marker: '1→', tone: 0 },
    'visual-search': { Icon: Search, tone: 1 },
    'flanker-direction': { Icon: ArrowLeftRight, tone: 2 },
    'go-no-go': { Icon: CircleStop, marker: 'GO', tone: 3 },
    'trail-making': { Icon: Route, marker: '1A', tone: 4 },
    'chance-cards': { Icon: GitCompareArrows, marker: '%', tone: 0 },
    'turn-match': { Icon: Box, tone: 1 },
    'number-rain': { Icon: CloudRain, tone: 2 },
    'order-rush': { Icon: ClipboardList, tone: 3 },
    'estimate-duel': { Icon: ChartNoAxesColumn, tone: 4 },
    'new-catch': { Icon: ScanEye, tone: 0 },
    'object-shelf': { Icon: LibraryBig, tone: 1 },
    'balance-beam': { Icon: Scale, tone: 2 },
    'percent-pop': { Icon: CirclePercent, tone: 3 },
    'orbit-tracker': { Icon: Orbit, tone: 4 },
    'tone-order': { Icon: ListMusic, tone: 0 },
    'focus-blink': { Icon: ScanText, marker: '12', tone: 1 },
    'rule-matrix': { Icon: Grid2X2Check, tone: 2 },
    'tower-plan': { Icon: Blocks, tone: 3 },
    'source-bind': { Icon: MapPinCheckInside, tone: 4 },
    'compass-route': { Icon: Compass, tone: 0 },
    'line-judge': { Icon: Ruler, tone: 1 },
    'dual-track': { Icon: Columns2, tone: 2 },
});

export const getBrainGameCardToneClass = (gameId, fallbackIndex = 0) => {
    const configuredTone = BRAIN_GAME_CARD_ICON_CONFIG[gameId]?.tone;
    const fallbackTone = Math.abs(Number.parseInt(fallbackIndex, 10) || 0) % 5;

    return `is-tone-${Number.isInteger(configuredTone) ? configuredTone : fallbackTone}`;
};

export default function BrainGameCardIcon({ gameId }) {
    const config = BRAIN_GAME_CARD_ICON_CONFIG[gameId] || { Icon: Puzzle };
    const { Icon, marker = '' } = config;

    return (
        <span
            aria-hidden="true"
            className={`UFOV-game__brain-card-icon${marker ? ' has-marker' : ''}`}
            data-game-icon={gameId || 'fallback'}
        >
            <Icon
                className="UFOV-game__brain-card-icon-glyph"
                focusable="false"
                strokeWidth={2.15}
            />
            {marker ? <span className="UFOV-game__brain-card-icon-marker">{marker}</span> : null}
        </span>
    );
}
